const valuableTypeTab = (() => {
  const pageValuable = (document.getElementById("pageValuable") != null);
  if (pageValuable) {


    {
      const jsTypeTabWrap = document.getElementById('jsTypeTabWrap1');
      const tab = jsTypeTabWrap.querySelectorAll('.js-tab-btn');
      const cntnt = jsTypeTabWrap.querySelectorAll('.js-tab-cntnt');
      const arrow = jsTypeTabWrap.querySelectorAll('.js-arrow');

      const actReset = () => {
        tab.forEach((element, index) => {
          tab[index].classList.remove('act')
          cntnt[index].classList.remove('act')
        });
      }

      tab.forEach((element, index) => {
        element.addEventListener('click', () => {
          actReset()
          tab[index].classList.add('act')
          cntnt[index].classList.add('act')
        });
      });

      arrow.forEach((element, index) => {
        element.addEventListener('click', () => {
          if (cntnt[0].classList.contains("act")) {
            actReset()
            tab[1].classList.add('act')
            cntnt[1].classList.add('act')
          } else {
            actReset()
            tab[0].classList.add('act')
            cntnt[0].classList.add('act')
          }
        });
      });
    }

    {
      const jsTypeTabWrap = document.getElementById('jsTypeTabWrap2');
      const tab = jsTypeTabWrap.querySelectorAll('.js-tab-btn');
      const cntnt = jsTypeTabWrap.querySelectorAll('.js-tab-cntnt');
      const arrow = jsTypeTabWrap.querySelectorAll('.js-arrow');

      const actReset = () => {
        tab.forEach((element, index) => {
          tab[index].classList.remove('act')
          cntnt[index].classList.remove('act')
        });
      }

      tab.forEach((element, index) => {
        element.addEventListener('click', () => {
          actReset()
          tab[index].classList.add('act')
          cntnt[index].classList.add('act')
        });
      });

      arrow.forEach((element, index) => {
        element.addEventListener('click', () => {
          if (cntnt[0].classList.contains("act")) {
            actReset()
            tab[1].classList.add('act')
            cntnt[1].classList.add('act')
          } else {
            actReset()
            tab[0].classList.add('act')
            cntnt[0].classList.add('act')
          }
        });
      });
    }


  }
})();
export default valuableTypeTab;